/* eslint-disable */
import { Fragment, useEffect } from 'react';
import { Link, Routes, Route } from "react-router-dom";
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'


// import GetFlow from './App/Flow/get_flow.components';
// import TestGetFlow from './App/Flow/test_get_flow.components';
// import NewGetFlow from './App/Flow/new_flow.component';
// import NewBot from './App/Flow/new_bot.components';
// import GetFlowTemplate from './App/Flow/get_flow_template.components';
// import SpreadsheetList from './App/Flow/testing.components';


// import Facebook from './App/Flow/newFlows/facebook';
// import Report from './App/Report/report.components';
// import Campaign from './App/Report/campaign.components';
// import Log from './App/Report/log.components';
// import Statistics from './App/Report/statistics.components';
// import LogInstant from './App/Report/log_instant.components';
// import BtnList from './App/Report/btn_list.components';
// import TempData from './App/Report/temp_data.components';
// import CampStatistics from './App/Report/camp_statistics.components';


// import Template from './App/Group/template.components';
// import NoRoute from './App/Group/no_route.components';
// import Login from './App/Auth/login.components'
// import Signup from './App/Auth/signup.components'
// import GoogleCallback from './App/Auth/googleSignUp.components'

import LoginAs from './App/Auth/login_as.components'
import AllFlow from './App/Flow/all_flow.components';
import NewOne from './App/Flow/test';
import Profile from './App/Report/profile.components';
import WebhookSetup from './App/Group/webhook_setup.components';
import NewReport from './App/Report/new_report.components';
import BsspSetup from './App/Group/bssp_setup.components';
import ThirdPartyApp from './App/Group/third_party_app.components';



const token = localStorage.getItem('token');
const user_id = localStorage.getItem('user_id');
const auth_key = localStorage.getItem('auth_key');


const logOut = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('auth_key');
    localStorage.removeItem('user_id');
    localStorage.removeItem('username');
    localStorage.removeItem('length');
    window.location.href = 'https://www.tickmaker.io/home';
}


const NoPath = () => {
    useEffect(() => {
        const timer = setTimeout(() => {
            const protocol = window.location.protocol; // "http:" or "https:"
            const domain = window.location.hostname;   // e.g., "example.com"
            const fullDomain = `${protocol}//${domain}/new`;
            window.location.href = fullDomain
        }, 5000);
        return () => clearTimeout(timer); // cleanup if component unmounts early
    }, []);
    return (
        <div className="flex items-center justify-center h-screen text-center">
            <div>
                <h1 className="text-4xl font-bold mb-4">404</h1>
                <p className="text-lg text-gray-600">Page Not Found</p>
            </div>
        </div>
    )
}

const HeaderNav = () => {
    return (
        <ul className="navbar-nav bg-gradient-primary1 sidebar sidebar-dark accordion" id="accordionSidebar">
            <Link className="sidebar-brand d-flex align-items-center justify-content-center">
                <div class="sidebar-brand-icon"><i class="fas fa-sitemap"></i></div>
                <div className="sidebar-brand-text mx-3"> Oiomni </div>
            </Link>

            <div className='sidebar-heading'> <i className="fa-solid fa-list-check"></i> Main Menu </div><hr className="sidebar-divider" />
            <li className="nav-item">
                <Link to="/new" className="nav-link"><i className="fas fa-sitemap"></i><span>New Bot</span></Link>
            </li>
            <li className="nav-item">
                <Link to="/all_flow" className="nav-link"><i className="fa-solid fa-list-check"></i><span>Bot List</span></Link>
            </li>
            <li className="nav-item">
                <Link to="/third_party_app" className="nav-link"><i className="fa fa-users" aria-hidden="true"></i><span>Third party Apps</span></Link>
            </li>
            <li className="nav-item">
                <Link to="/webhook_setup" className="nav-link"> <i className="fa-solid fa-sliders"></i><span> Bot Webhook </span></Link>
            </li>
            <li className="nav-item">
                <button onClick={logOut} className="nav-link"><i className="fas fa-power-off"></i><span> Logout </span></button>
            </li>
        </ul>
    )
}



const Includer1 = (props) => {
    const queryClient = new QueryClient();

    return (
        <div id="wrapper">
            <HeaderNav />
            <QueryClientProvider client={queryClient}>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <props.cont />
                    </div>
                </div>
                <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
        </div>
    )
}

const Includer2 = (props) => {
    const queryClient3 = new QueryClient();
    return (
        <div id="wrapper">
            <QueryClientProvider client={queryClient3}><props.cont /></QueryClientProvider>
        </div>
    )
}




export default function App() {

    
    const queryClient2 = new QueryClient();

    if (!!token || token !== "") {
        return (
            <Routes>
                {/*
                    <Route exact path="/Facebook" element={<Includer1 cont={Facebook} /> } />
                    <Route exact path="/new_bot" element={<Includer1 cont={NewBot} />} />
                    <Route exact path="/Template" element={<Includer1 cont={Template} />} />
                    <Route exact path="/new_acc" element={<Includer1 cont={SpreadsheetList} />} />
                    <Route exact path="/report/:id" element={<Includer1 cont={Report} />} />
                    <Route exact path="/campaign/:id" element={<Includer1 cont={Campaign} />} />
                    <Route exact path="/log/:id" element={<Includer1 cont={Log} />} />
                    <Route exact path="/statistics/:id" element={<Includer1 cont={Statistics} />} />
                    <Route exact path="/temp_data/:id" element={<Includer1 cont={TempData} />} />
                    <Route exact path="/log_instant/:id" element={<Includer1 cont={LogInstant} />} />
                    <Route exact path="/button_list/:id" element={<Includer1 cont={BtnList} />} />
                    <Route exact path="/camp_statistics/:id" element={<Includer1 cont={CampStatistics} />} />
                    <Route exact path="/flow/:id" element={<Includer2 cont={NewGetFlow} />} />
                    <Route exact path="/testflow/:id" element={<Includer2 cont={TestGetFlow} />} />
                    <Route exact path="/flow_template/:id" element={<GetFlowTemplate />} />
                    <Route exact path="/google/callback" element={<GoogleCallback />} />
                */}
                
                <Route exact path="/bssp_setup" element={<Includer1 cont={BsspSetup} />} />
                <Route exact path="/loginas/:id" element={<Includer1 cont={LoginAs} />} />

                <Route exact path="/webhook_setup" element={<Includer1 cont={WebhookSetup} />} />
                <Route exact path="/all_flow" element={<Includer1 cont={AllFlow} />} />
                <Route exact path="/profile" element={<Includer1 cont={Profile} />} />
                <Route exact path="/new_report/:id" element={<Includer1 cont={NewReport} />} />
                <Route exact path="/third_party_app" element={<Includer1 cont={ThirdPartyApp} />} />

                <Route exact path="/new" element={<Includer2 cont={NewOne} />} />
                <Route exact path="/new/:id" element={<Includer2 cont={NewOne} />} />
                <Route path="*" element={<NoPath />} />
            </Routes>
        )
    } else {
        return (
            <QueryClientProvider client={queryClient2}>
                <Routes>
                    <Route exact path="/loginas/:id" element={<LoginAs />} />
                    <Route path="*" element={<NoPath />} />
                </Routes>
            </QueryClientProvider>
        )
    }
}